export default "__VITE_ASSET__BCLjCIgI__"